export function convertToCSSPrefix(property) {
  return property.replace(/^Moz/, "-moz-").replace(/^ms/, "-ms-").replace(/^O/, "-o-").replace(/^Webkit/, "-webkit-").toLowerCase();
}
export default convertToCSSPrefix;